import { resultSlider } from './resultSlider';

const Component = {
  init() {
    resultSlider.init();
  },
};

export { Component };
